import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["arrivalDate", "departureDate", "guests", "price"]

  connect() {
    console.log('Admin booking form controller connected')
    console.log('Targets:', {
      hasArrivalDate: this.hasArrivalDateTarget,
      hasDepartureDate: this.hasDepartureDateTarget,
      hasGuests: this.hasGuestsTarget,
      hasPrice: this.hasPriceTarget
    })
    // Calculate price on initial load if dates are present
    if (this.hasArrivalDateTarget && this.hasDepartureDateTarget && this.hasGuestsTarget) {
      this.calculatePrice()
    }
  }

  calculatePrice() {
    console.log('calculatePrice called')
    const arrivalDate = this.arrivalDateTarget.value
    const departureDate = this.departureDateTarget.value
    const guests = this.guestsTarget.value

    console.log('Form values:', { arrivalDate, departureDate, guests })

    // Only calculate if we have all required values
    if (!arrivalDate || !departureDate || !guests) {
      console.log('Missing required values, skipping calculation')
      return
    }

    // Validate dates — allow equal dates for same-night stays; server-side validation handles min stay
    if (new Date(arrivalDate) > new Date(departureDate)) {
      console.log('Invalid dates: arrival must be on or before departure')
      return
    }

    // Build query parameters
    const params = new URLSearchParams({
      arrival_date: arrivalDate,
      departure_date: departureDate,
      number_of_guests: guests
    })

    console.log('Fetching price from API:', `/api/bookings/price?${params}`)

    // Fetch price from API
    fetch(`/api/bookings/price?${params}`)
      .then(response => {
        console.log('API response status:', response.status)
        if (!response.ok) {
          throw new Error('Failed to fetch price')
        }
        return response.json()
      })
      .then(data => {
        console.log('Price data received:', data)
        // Update price field with calculated value
        if (this.hasPriceTarget && data.price !== undefined && data.price !== null) {
          const price = parseFloat(data.price)
          this.priceTarget.value = price.toFixed(2)
          console.log('Price field updated to:', this.priceTarget.value)
        } else {
          console.log('Price target not available or price undefined')
        }
      })
      .catch(error => {
        console.error('Error calculating price:', error)
      })
  }
}
